import { useEffect } from 'react';

import { TopAreaBlock } from '../components';
import { TopArea } from '../components/TopArea';
import { AB_TASTY_SCRIPT_URL } from '../constants';
import { useTopAreaBanner } from '../context';
import { useAboutTiles, useInspirationTiles, useJoinTiles, useShopSection } from '../context/navigation';
import {
  useClickSignInButtonSupportCenter,
  useLoadAbTastyScript,
  useManagedHeight,
  usePersonalMenuPortal,
  useReturnUrl,
  useToggleMenuHandler,
} from '../hooks';

export const Content = () => {
  const personalMenu = usePersonalMenuPortal();
  const { visible: isTopBannerVisible } = useTopAreaBanner();
  const { fetch: fetchAboutTiles } = useAboutTiles();
  const { fetch: fetchInspirationTiles } = useInspirationTiles();
  const { fetch: fetchJoinTiles } = useJoinTiles();
  const { fetch: fetchShopSection } = useShopSection();
  useLoadAbTastyScript(AB_TASTY_SCRIPT_URL);

  useClickSignInButtonSupportCenter();
  useManagedHeight();
  useReturnUrl();
  useToggleMenuHandler();
  useEffect(() => {
    fetchAboutTiles();
    fetchInspirationTiles();
    fetchJoinTiles();
    fetchShopSection();
  }, [fetchAboutTiles, fetchInspirationTiles, fetchJoinTiles, fetchShopSection]);

  return (
    <TopAreaBlock>
      <TopArea
        isTopBannerVisible={isTopBannerVisible}
        personalMenu={personalMenu}
      />
    </TopAreaBlock>
  );
};
